<template>
    <div class="page">
        <Header title="发布沙龙" />
        <div class="header">
            <img class="image" :src="form.cover_img" v-if="form.cover_img" />
            <UploadAvatar class="camera" @callback="callbackCoverImg"></UploadAvatar>
        </div>
        <div class="body">
            <div>
                <label>沙龙名称</label>
                <div class="input">
                    <input type="text" placeholder="请输入" v-model="form.name" />
                </div>
            </div>
            <div class="textarea">
                <label>沙龙描述</label>
                <div class="input">
                    <textarea type="text" placeholder="请输入" v-model="form.salon_desc" rows="4"></textarea>
                </div>
            </div>
            <div>
                <label>报名截止时间</label>
                <div class="input" @click="selectDateTime" data-field="expire_time">
                    <input type="text" placeholder="请选择报名截止时间" v-model="form.expire_time" readonly />
                </div>
            </div>
            <div>
                <label>沙龙开始时间</label>
                <div class="input" @click="selectDateTime" data-field="start_time">
                    <input type="text" placeholder="请选择沙龙开始时间" v-model="form.start_time" readonly />
                </div>
            </div>
            <div>
                <label>沙龙结束时间</label>
                <div class="input" @click="selectDateTime" data-field="end_time">
                    <input type="text" placeholder="请选择沙龙结束时间" v-model="form.end_time" readonly />
                </div>
            </div>
            <div>
                <label>地区</label>
                <div class="input" @click="selectArea">
                    <input type="text" placeholder="请选择地区" v-model="form.area" readonly />
                </div>
                <img class="icon" :src="Images.icon_arrow_right1" />
            </div>
            <div>
                <label>详细地址</label>
                <div class="input">
                    <input type="text" placeholder="请输入详细地址" v-model="form.address" />
                </div>
            </div>
            <div>
                <label>获取定位</label>
                <div class="input" @click="pickerLocation">
                    <input type="text" placeholder="请选择" v-model="location" readonly />
                </div>
                <img class="icon" :src="Images.icon_arrow_right1" />
            </div>
            <div>
                <label>传承师</label>
                <div class="input" @click="pickerMaster">
                    <input type="text" placeholder="请选择传承师" v-model="master_name" readonly />
                </div>
                <img class="icon" :src="Images.icon_arrow_right1" />
            </div>
            <div class="upload">
                <label>沙龙详情</label>
                <div class="input">
                    <UploadImage :max="1" :fileListData="fileList" @callback="callbackUploadImage"></UploadImage>
                </div>
            </div>
        </div>
        <div class="btn-box td-fbc">
            <Btn class="btn" loading @confirmEvent="temporary" data-type="temporary">暂存</Btn>
            <!-- <Btn class="btn" loading @confirmEvent="preview" data-type="preview">预览查看</Btn> -->
            <Btn class="btn" loading @confirmEvent="save" data-type="save">提交发布</Btn>
        </div>
        <!-- 地址选择 -->
        <PickerArea ref="PickerArea" :show="showArea" @confirm="areaConfirm" @cancel="areaCancel"></PickerArea>
        <!-- 地图选点 -->
        <PickerLocation ref="mapLocation" :keyword="form.area + form.address" @confirm="callbackLocation"></PickerLocation>
        <!-- 时间选择 -->
        <PickerDateTime ref="dateTime" @confirm="callbackDateTime"></PickerDateTime>
        <!-- 传承师选择 -->
        <PickerMaster ref="master" @confirm="callbackMaster"></PickerMaster>
    </div>
</template>
<script>
import Header from "../../components/Header";
import UploadAvatar from "@/components/UploadAvatar";
import UploadImage from "@/components/UploadImage";
import PickerArea from "@/components/PickerArea";
import PickerLocation from "@/components/PickerLocation";
import PickerDateTime from "@/components/PickerDateTime";
import PickerMaster from "@/components/PickerMaster";

export default {
    components: {
        Header: Header,
        UploadAvatar,
        UploadImage,
        PickerArea,
        PickerLocation,
        PickerDateTime,
        PickerMaster,
    },
    data() {
        return {
            id: this.$route.query.id || '',
            form: {
                name: '',
                salon_desc: '',
                expire_time: '',
                start_time: '',
                end_time: '',
                area: '',
                address: '',
                lat: '',
                lng: '',
                cover_img: '',
                detail_img: '',
                master_id: '',
            },
            location: '',
            master_name: '',
            area: [],
            showArea: false,
            showLocation: false,
            fileList: [],
            // 日期选择
            dateTimeField: '',
        };
    },
    mounted() {
        this.wrapperHeight = document.documentElement.clientHeight;
        let dataForm = this.Lockr.get('data-form')
        if (dataForm) {
            this.form = dataForm
        }
        this._onRequestDataSources();
    },
    methods: {
        async _onRequestDataSources() {
            if (!this.id) return;
            let url = this.API.salon_detail;
            let params = {
                id: this.id,
                token: this.Lockr.get('token') || ''
            };
            let result = await this.$post(url, params);
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                this._onFormatterData(result.data);
            } else {
                this.Message({
                    title: result.msg,
                });
            }
        },

        _onFormatterData(data) {
            this.form = data;
            this.form['expire_time'] = data.expire_time_text;
            this.location = `${data.lng},${data.lat}`;
            this.master_name = data.master_name;
            this.fileList = [{url: data.detail_img, img_src: data.detail_img}];
        },

        // 打开地址选择
        selectArea() {
            this.showArea = true;
        },
        // 地址选择确认
        areaConfirm(res) {
            this.showArea = false;
            console.log("地址选择返回", res);
            let area = '';
            res.forEach((element) => {
                area += element.name;
            });
            this.area = res;
            this.form.area = area;
        },
        // 地址选择取消
        areaCancel() {
            this.showArea = false;
        },
        afterRead(file) {
            file.status = "uploading";
            file.message = "上传中...";

            setTimeout(() => {
                file.status = "failed";
                file.message = "上传失败";
            }, 1000);
        },
        pickerLocation() {
            if (!this.form.area && !this.form.address) {
                return this.ToastManager('请先设置地址信息');
            }
            this.$refs.mapLocation.open();
        },
        // 选择位置回调
        callbackLocation(res) {
            var lat = res.lat.toFixed(6);
            var lng = res.lng.toFixed(6);
            this.form.lat = lat;
            this.form.lng = lng;
            this.location = `${lng},${lat}`;
        },
        selectDateTime(e) {
            let {
                field
            } = e.currentTarget.dataset;
            this.dateTimeField = field;
            this.$refs.dateTime.open();
        },
        // 选择位置回调
        callbackDateTime(res) {
            this.form[this.dateTimeField] = res;

            console.log('this.dateTimeField, res, this.form[this.dateTimeField]---->', this.dateTimeField, res, this.form);
        },
        pickerMaster() {
            this.$refs.master.open();
        },
        callbackMaster(res) {
            console.log("callbackMaster", res);
            this.master_name = res.inheritor_name;
            this.form.master_id = res.id;
        },
        callbackCoverImg(res) {
            console.log('callbackCoverImg---->', res);
            this.form.cover_img = res;
        },
        callbackUploadImage(res) {
            this.fileList = res;
        },
        temporary(done) {
            console.log('this.Utils---->', this.Utils);
            let _count = 0;
            for(let key in this.form) {
                if (this.form[key]) _count++;
            }
            if (_count < 1) {
                this.ToastManager('没有数据，无需保存');
                return done && done();
            }
            this.validateForm(done, 'temporary')
        },
        preview(done) {
            this.validateForm(done, 'preview')
        },
        save(done) {
            this.validateForm(done, 'save')
        },

        _getPoint(location) {
            let myGeo = new BMapGL.Geocoder();
            myGeo.getPoint(location, (point) => {
                console.log('point---->', point);
                if (point) {
                    this.form.lng = point.lng;
                    this.form.lat = point.lat;
                } else {
                    return this.ToastManager("当前位置没有正确获取经纬度，请确认地址信息");
                }
            });
        },

        // 验证
        async validateForm(done, type) {
            this.Lockr.set('data-form', this.form)
            if (this.fileList.length) {
                this.form.detail_img = this.fileList[0].img_src;
            }
            let form = this.form;
            if (type == 'save') {
                if (!form.cover_img) {
                    this.Message({
                        title: "请选择沙龙封面图",
                    });
                    return done && done();
                }
                if (!form.name) {
                    this.Message({
                        title: "请输入沙龙名称",
                    });
                    return done && done();
                }
                if (!form.salon_desc) {
                    this.Message({
                        title: "请输入沙龙简介",
                    });
                    return done && done();
                }
                if (!form.expire_time) {
                    this.Message({
                        title: "请输入沙龙报名截止时间",
                    });
                    return done && done();
                }
                if (!form.start_time) {
                    this.Message({
                        title: "请输入沙龙开始时间",
                    });
                    return done && done();
                }
                if (!form.end_time) {
                    this.Message({
                        title: "请输入沙龙结束时间",
                    });
                    return done && done();
                }
                if (!form.area) {
                    this.Message({
                        title: "请选择举办沙龙所在省市区",
                    });
                    return done && done();
                }
                if (!form.area) {
                    this.Message({
                        title: "请输入举办沙龙详细地址",
                    });
                    return done && done();
                }
                // if (!form.lat || !form.lng) {
                //     this.Message({
                //         title: "请选择沙龙位置",
                //     });
                //     return done && done();
                // }
                if (!form.master_id) {
                    this.Message({
                        title: "请选择沙龙传承师",
                    });
                    return done && done();
                }
                if (!form.detail_img) {
                    this.Message({
                        title: "请上传沙龙详情图",
                    });
                    return done && done();
                }
            }

            if (this.form.area || this.form.address) {
                this._getPoint(this.form.area + this.form.address);
            }

            if (type == "temporary" || type == "save") {
                let url = this.API.save_salon;
                let params = this.form;
                params.is_pass = type == "temporary" ? 0 : 1
                params.token = this.Lockr.get('token')
                let result = await this.$post(url, params);
                done && done();
                this.Lockr.rm('data-form');
                if (result.code === this.GLOBAL.SUCCESS_CODE) {
                    this.Message({
                        title: result.msg,
                        onClose: () => {
                            this.$router.go(-1)
                        }
                    })
                } else {
                    this.Message({
                        title: result.msg
                    });
                }
            } else {

            }
        }
    },
};
</script>
<style lang="less" scoped>
.page {
    padding: 15px;
}

.header {
    position: relative;
    background: #fff;
    border-radius: 10px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 10px;
    min-height: 150px;

    .image {
        width: 100%;
        height: 150px;
    }

    .camera {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        transform: translate(-50%, -50%);
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    }

    p {
        font-size: 16px;
        color: #7181eb;
    }
}

.body {
    padding: 0 10px;
    background: #ffffff;
    border-radius: 10px;

    >div {
        width: 100%;
        min-height: 50px;
        display: flex;
        align-items: center;
        border-bottom: 1px dashed #f3f0ee;

        label {
            font-size: 15;
            color: #666;
            margin-right: 10px;
        }

        .input {
            flex: 1;

            input {
                border: none;
                font-size: 15px;
                color: #333;
                width: 100%;
                text-align: right;
            }
        }

        .icon {
            width: 8px;
            height: 15px;
            margin-left: 10px;
        }

        &:last-child {
            border-bottom: none;
        }

        &.upload {
            flex-direction: column;
            align-items: flex-start;
            justify-content: flex-start;

            label {
                line-height: 50px;
            }
        }

        &.textarea {
            flex-direction: column;
            align-items: flex-start;
            justify-content: flex-start;

            .input {
                width: 100%;
            }

            label {
                line-height: 50px;
            }

            textarea {
                width: 100%;
                background-color: #f8f8f8;
                border: none;
                box-sizing: border-box;
                padding: 10px;
                border-radius: 4px;
            }
        }
    }
}

.btn-box {
    margin: 15px 0;

    .btn {
        flex: 1;
        color: #fff;
        height: 40px;
        min-width: 28%;
        font-size: 15px;
        margin-left: 15px;
        line-height: 40px;
        text-align: center;
        border-radius: 3px;
        background: linear-gradient(225deg, #9cb2f4, #6472e8);
        &:first-of-type {
            margin-left: 0;
        }
    }
}
</style>